import React from 'react';
import ReactJson from 'react-json-view'

import { LogIcon } from '@primer/octicons-react';
import { StyledOcticon } from '@primer/react';

import ErrorLabel from '../common/Labels/ErrorLabel';

type LogJsonViewProps = {
  data: any,
}

export const LogJsonView = ({ data }: LogJsonViewProps) => (
  <div className={`mt-4 py-2 px-4 w-full bg-white border border-border-dark rounded flex items-start justify-${data ? 'start' : 'center'} overflow-y-scroll`}>
    {
      data ? (
        <div className="mt-2 flex justify-start">
          <ReactJson
            src={data}
            indentWidth={2}
            name={false}
            displayDataTypes={false}
            quotesOnKeys
          />
        </div>
      ) : (
        <div className="p-4 flex flex-col justify-center items-center h-full text-center">
          <StyledOcticon
            className="mb-4 text-brand"
            icon={LogIcon}
            size={32}
          />
          <ErrorLabel className="mt-2" size="lg">
            Select a log entry from the left to see it here
          </ErrorLabel>
        </div>
      )
    }
  </div>
)

export default LogJsonView;
